import React, { useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
//import { useAuth } from '../../../../../services/useAuth'; 

export default function BalanceButtonGroup() {
  //const { token22 } = useAuth();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get userType from localStorage (assume string: "2", "3", "4")
  const userType = localStorage.getItem('userType');

  // Show Balance only for agency, agency user, individual user
  const show = userType === "2" || userType === "3" || userType === "4";



useEffect(() => {
  if (!show) return;
  const interval = setInterval(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setLoading(true);
      fetch('/api/get_agency_details', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, agency_id: null })
      })
        .then(res => res.json())
        .then(data => setDetails(data))
        .catch(() => setDetails(null))
        .finally(() => setLoading(false));
      clearInterval(interval);
    }
  }, 250);
  return () => clearInterval(interval);
}, [show]);



  if (!show) return null;

  if (loading) {
    return <CircularProgress size={22} color="inherit" sx={{ my: 1, mx: 2 }} />;
  }
  if (!details) {
    return null;
  }

  // Calculate "remaining" for display
  const postsAllocated = details.total_posts_allocated || 0;
  const postsDone = details.total_posts_done || 0;
  const messagesAllocated = details.total_messages_allocated || 0;
  const messagesDone = details.total_messages_done || 0;

  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ mx: 1 }}>
      <Tooltip
        title={
          <>
            Allocated Posts: {postsAllocated}<br />
            Posts Done: {postsDone}<br />
            Remaining Posts: {postsAllocated - postsDone}
          </>
        }
        arrow
        enterTouchDelay={0}
      >
        <Button
          variant="outlined"
          size="small"
          sx={{ minWidth: 95, fontWeight: 500, borderRadius: 2, bgcolor: '#ede7f6' }}
        >
          Posts: {postsAllocated - postsDone}/{postsAllocated}
        </Button>
      </Tooltip>
      <Tooltip
        title={
          <>
            Allocated Messages: {messagesAllocated}<br />
            Messages Done: {messagesDone}<br />
            Remaining Messages: {messagesAllocated - messagesDone}
          </>
        }
        arrow
        enterTouchDelay={0}
      >
        <Button
          variant="outlined"
          size="small"
          sx={{ minWidth: 120, fontWeight: 500, borderRadius: 2, bgcolor: '#ede7f6' }}
        >
          Messages: {messagesAllocated - messagesDone}/{messagesAllocated}
        </Button>
      </Tooltip>
    </Stack>
  );
}
